import type { ReactNode } from 'react';

import { useMaintenanceMode } from '../hooks/useMaintenanceMode';
import { MaintenanceScreen } from './MaintenanceScreen';

/**
 * Compuerta de `web-mantenimiento` sobre TODA la app. En mantenimiento pinta la
 * pantalla y `children` ni se monta (ni router, ni sesión, ni consultas). No
 * espera a GrowthBook: mientras el payload no llega el flag vale `false` y la
 * app carga normal, igual que hoy; si llega encendido, la pantalla la reemplaza.
 */
export const MaintenanceGate = ({ children }: { children: ReactNode }) =>
	useMaintenanceMode() ? <MaintenanceScreen /> : children;
